module.exports = __webpack_public_path__ + "assets/img/zbt_5.fb06906d.png";